// A static bid below the campaign's category minimum disables its target in Ringba. The minimum
// arrives with each loaded campaign's category. Kept out of campaign.store, which components
// cannot import without pulling in the whole store.

// campaignRoutingTypes.Static; campaign.store cannot be imported from here for the same reason
const STATIC_ROUTING_TYPE = 'Static'

// 0 means there is no minimum to hold
export function getStaticCampaignMinBid(campaign) {
  if (campaign?.routing?.type !== STATIC_ROUTING_TYPE) return 0

  return Number(campaign.category?.bidPreferences?.minBid) || 0
}

export function getMinBidMessage(minBid) {
  return `Minimum bid for this campaign is $${Number(minBid).toFixed(2)}`
}
